import React from "react";

function PengeAlert(props) {
  return (
    <div className={`pengeAlert ${props.variant}`}>
      <span className="text">{props.text}</span> {props.children}
    </div>
  );
}

export default PengeAlert;
